import { render, staticRenderFns } from "./MarketingCampaignReport.vue?vue&type=template&id=509b0941&"
import script from "./MarketingCampaignReport.vue?vue&type=script&lang=js&"
export * from "./MarketingCampaignReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports